module.exports = __webpack_public_path__ + "static/berbli-d3cba2775bb0a67a4c305ecf86cca2b0.jpg";